import { render, staticRenderFns } from "./stuCenter.vue?vue&type=template&id=9c0b928e&scoped=true&"
import script from "./stuCenter.vue?vue&type=script&lang=js&"
export * from "./stuCenter.vue?vue&type=script&lang=js&"
import style0 from "./stuCenter.vue?vue&type=style&index=0&id=9c0b928e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0b928e",
  null
  
)

export default component.exports